import { render, staticRenderFns } from "./ImsInfo.vue?vue&type=template&id=56031beb&"
import script from "./ImsInfo.vue?vue&type=script&lang=js&"
export * from "./ImsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports